export enum Recurrence {
  None = "NONE",
  Daily = "DAILY",
  OnEntrance = "ON_ENTRANCE",
}
